module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('a', {
    attrs: {
      "id": "page_v"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "dedi1"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("To my sons: Samuel Washington Maloy and Thomas Mercer Maloy.")])]), _vm._v(" "), _c('p', {
    staticClass: "dedi"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("I hope one day, you too will find inspiration from the heroes of the past…")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4c3a21be","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/05_Dedication.vue
// module id = 69
// module chunks = 0